import {computed, makeObservable} from "mobx";
import {BaseModel} from "../../../../infrastructure/models/base-model";
import type {ChartEventsViewModel} from "../../../../domain/full-game/models/chart-events/chart-events.view-model";

export class CompetitorPlayerStatsModuleSportModel extends BaseModel {
  events: ChartEventsViewModel
  constructor() {
    super();

    makeObservable(this)
  }

  @computed get shouldRenderAnimation(): Boolean {
    return console.error(this.constructor.name + 'Implementation is missing: shouldRenderAnimation');
  }

  @computed get shouldRenderSelector(): Boolean {
    return console.error(this.constructor.name + 'Implementation is missing: shouldRenderSelector');
  }

  @computed get contextClassName(): Boolean {
    return console.error(this.constructor.name + 'Implementation is missing: contextClassName');
  }

  @computed get courtRatio(): Number {
    return console.error(this.constructor.name + 'Implementation is missing: courtRatio');
  }

  @computed get courtType(): Number {
    return console.error(this.constructor.name + 'Implementation is missing: courtRatio');
  }
}